import { CircularProgress } from "@mui/material";
import { Icon } from "../../components/Icon";
import { P } from "../../components/Typography";

export const DashboardBlockTitle = ({ iconName, children, isPending }) => (
  <P sx={{ fontWeight: 500 }}>
    {isPending ? (
      <CircularProgress color="inherit" size={14} sx={{ opacity: 1, mr: 1 }} />
    ) : (
      <Icon name={iconName} sx={{ fontSize: "inherit", mr: 0.5 }} />
    )}
    {children}
  </P>
);
